import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.fw{min-height:100vh;}.ssr-plugin'
import '.e1{background:var(--palette-white);}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.fx{align-self:center;}.ssr-plugin'
import '.af{flex-shrink:0;}.ssr-plugin'
import '.fy{padding-block:1rem;}.ssr-plugin'
import '.fh{gap:0.75rem;}.ssr-plugin'
import '.fz{height:3rem;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.g0{height:0.25rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.g1{border-radius:999px;}.ssr-plugin'
import '.g2{background:var(--gray-200);}.ssr-plugin'
import '.aj{height:100%;}.ssr-plugin'
import '.cj{background:var(--brand-primary);}.ssr-plugin'
import '.g3{transition:width 0.3s ease;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import '.cy{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.g4{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d e fw e1"
      >
        <div className="ab fx af"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="fy d e fh"
          >
            <div className="fz d ao t ar"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="g0 l g1 g2"
              >
                <div className="aj g1 cj g3"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="al cy d e r g4 ab fx"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
